/**
 * GlobalFooter — appears at the bottom of every page.
 *
 * Two lines: emotional poetic framing + AI transparency disclaimer.
 * Kept deliberately understated (textLow, small type) so it never
 * competes with the main experience, but is always present for legal
 * and emotional clarity.
 */
import { useLocale } from "@/lib/locale";

export default function GlobalFooter() {
    const { t } = useLocale();
    return (
        <footer
            className="relative z-10 border-t border-ink-border/60 bg-ink-deep/60 backdrop-blur-sm"
            data-testid="global-footer"
        >
            <div className="max-w-4xl mx-auto px-6 md:px-12 py-8 md:py-10 text-center space-y-2">
                <p className="font-serif italic text-ink-textMid text-sm md:text-base leading-relaxed" data-testid="footer-line1">
                    {t("footer.line1")}
                </p>
                <p className="text-ink-textLow text-xs md:text-sm leading-relaxed" data-testid="footer-line2">
                    {t("footer.line2")}
                </p>
                <p className="pt-1 text-xs md:text-sm text-ink-textLow">
                    <a
                        href="mailto:os.otherside.app@gmail.com"
                        className="text-ink-gold hover:text-ink-goldHi underline underline-offset-4 decoration-ink-gold/40 hover:decoration-ink-gold transition-colors"
                        data-testid="footer-mailto"
                    >
                        os.otherside.app@gmail.com
                    </a>
                </p>
            </div>
        </footer>
    );
}
